<!-- eslint-disable vue/no-v-html -->
<template>
  <a
    :href="result.pagePath"
    class="
      list-group-item list-group-item-action
      flex-wrap flex-md-nowrap
      d-flex
      align-items-start
      p-sm-3 p-md-4
      overflow-hidden
    "
  >
    <div class="col-12 col-md-8 col-lg-9 m-0 p-0 order-2 order-md-1">
      <h5 class="mb-1">
        {{ result.title }}
      </h5>
    </div>

    <div
      class="
        col-12 col-md-4 col-lg-3
        text-md-right
        mb-1 mb-md-0
        p-0
        order-1 order-md-2
        d-flex d-md-block
      "
    >
      <span class="d-md-block col m-0 p-0">{{ date }}</span>

      <span
        v-if="searchTerm && result.score"
        class="d-md-block small ml-2 ml-md-0"
      >
        <span class="text-uppercase">
          <strong
            class="pr-1"
            style="font-size: 10px; color: rgba(0, 0, 0, 0.4)"
          >
            {{ content.score }}:
          </strong>
        </span>
        <span class="text-danger font-weight-bold">{{ relevance }}</span>
      </span>
    </div>
  </a>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import { formatDate, formatNumber } from '@/src/utilities/formatters';

const { mapGetters } = createNamespacedHelpers('search');

export default {
  name: 'SearchResult',

  components: {},

  props: {
    /** @type {import('vue').PropOptions<import('../store/state').SearchResult>} */
    result: {
      required: true,
      type: Object,
    },
  },

  computed: {
    ...mapGetters(['maxRelevance', 'content', 'searchTerm', 'culture']),

    /**
     * @returns {string}
     */
    relevance() {
      return formatNumber(this.result.score * 100, this.culture);
    },

    /**
     * @returns {string}
     */
    date() {
      return formatDate(this.result.date, this.culture);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/src/styles/variables';
</style>
